//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import CostCenterList from '@/views/costCenter/ListCostCenter'

//
export default {
    path: 'cost_center',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'cost-centers-list',
            component: CostCenterList,
        },
    ],
    meta: {
        group: 'Contabilidad',
        title: 'Centros de costos',
    },
}
